'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttonNext = require('wix-ui-core/button-next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _Close = require('../new-icons/system/Close');

var _Close2 = _interopRequireDefault(_Close);

var _CloseLarge = require('../new-icons/system/CloseLarge');

var _CloseLarge2 = _interopRequireDefault(_CloseLarge);

var _backoffice = require('wix-ui-core/themes/backoffice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloseButton = (_temp = _class = function (_Component) {
  _inherits(CloseButton, _Component);

  function CloseButton() {
    _classCallCheck(this, CloseButton);

    return _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).apply(this, arguments));
  }

  _createClass(CloseButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          skin = _props.skin,
          size = _props.size,
          className = _props.className,
          dataHook = _props.dataHook,
          rest = _objectWithoutProperties(_props, ['skin', 'size', 'className', 'dataHook']);

      var classNames = (0, _classnames2.default)(className, (0, _backoffice.closeButton)(skin, size));
      var CloseIcon = _react2.default.createElement(_Close2.default, { 'data-hook': 'close' });
      var CloseLargeIcon = _react2.default.createElement(_CloseLarge2.default, { 'data-hook': 'close-large' });

      return _react2.default.createElement(
        _buttonNext.ButtonNext,
        _extends({}, rest, { 'data-hook': dataHook, className: classNames }),
        size === 'small' ? CloseIcon : CloseLargeIcon
      );
    }
  }]);

  return CloseButton;
}(_react.Component), _class.displayName = 'CloseButton', _class.propTypes = {
  /** additional css classes */
  className: _propTypes.string,
  /** skins of closebutton */
  skin: (0, _propTypes.oneOf)(['standard', 'standardFilled', 'light', 'lightFilled', 'dark']),
  /** size of closebutton */
  size: (0, _propTypes.oneOf)(['small', 'medium']),
  /** Click event handler  */
  onClick: _propTypes.func,
  /** applies disabled styles */
  disabled: _propTypes.bool,
  /** string based data hook for testing */
  dataHook: _propTypes.string
}, _class.defaultProps = {
  skin: 'standard',
  size: 'small',
  disabled: false
}, _temp);
exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/CloseButton/CloseButton.js
// module id = 1346
// module chunks = 0